import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {MatBadgeModule} from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule  } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatStepperModule} from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatListModule} from '@angular/material/list';
import { NgxFileDropModule } from 'ngx-file-drop';

//// FUSE
import { FuseSidebarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseDemoModule } from '@fuse/components/demo/demo.module';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';

import { NgxChartsModule } from '@swimlane/ngx-charts';

// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';

// SWEETALERT
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

/// COMPONENTES
import { WizardLeaderComponent } from '../wizard-leader.component';
// CERTIFICAR
//idiomas
// import { IdiomasComponent } from 'app/main/pagina/productos/leaderGo/idiomas/idiomas.component';
// import { ModalIdioma } from 'app/main/pagina/productos/leaderGo/idiomas/modalIdioma.component';
//FORALL
// import { ForAllTabsComponent } from '../../pagina/pulse/4all/forAllTabs/forAllTabs.component';
// import { SidebarComponent } from '../../pagina/pulse/4all/forAllTabs/sidebar/sidebar.component';
// import { NativeComponent } from '../../pagina/pulse/4all/native/native.component';
// import { TranslateComponent } from '../../pagina/pulse/4all/translate/translate.component';
// import { PreviewComponent } from '../../pagina/pulse/4all/preview/preview.component';

//DEMOGRAFICOS
// import { DemoTabsComponent } from '../../pagina/pulse/demographictabs/demotabs.component';
// import { PreguntaDemoComponent } from '../../pagina/pulse/demographictabs/demographic/pregunta/pregunta.component';
// import { DemographicComponent } from '../../pagina/pulse/demographictabs/demographic/demographic.component';
// import { DemoTranslateComponent } from '../../pagina/pulse/demographictabs/demotranslate/demotranslate.component';
// import { DemoPreviewComponent } from '../../pagina/pulse/demographictabs/demopreview/demopreview.component';
// import { DragComponent } from '../../pagina/pulse/demographictabs/drag/drag.component';

//ADICIONALES
// import { AdicionalesModule } from '../../pagina/pulse/adicionales/adicional.module';
// import { AdicionalComponent } from '../../pagina/pulse/adicionales/adicional.component';

//COLABORADORES
// // import { UploadDBComponent } from '../../pagina/pulse/colabs/colabs.component';
// import { ColaboradoresModule } from '../../pagina/pulse/colaboradores/colaboradores.module';
// import { ColaboradoresComponent } from '../../pagina/pulse/colaboradores/colaboradores.component';
// import { ColaboradoresV2Module } from '../../pagina/pulse/colaboradores-v2/colaboradores-v2.module';
// import { ColaboradoresV2Component } from '../../pagina/pulse/colaboradores-v2/colaboradores-v2.component';


//PROGRAMACION
// import { SheduleComponent } from '../../pagina/pulse/shedulesurvey/shedule.component';
// import { ProgramacionModule } from "app/main/pagina/pulse/programacion/programacion.module";
// import { ProgramacionComponent } from "app/main/pagina/pulse/programacion/programacion.component";


//ENVIO
// import { DispatchComponent } from '../../pagina/pulse/dispatch/dispatch.component';

//CLOSE
// import { CloseComponent } from '../../pagina/pulse/close/close.component';
// import { ProjectDashboardComponent } from '../../pagina/pulse/cierre/cierre.component';

//import {  DataStep1Component } from '../../pagina/pulse/step1-norm35/step1-norm35.component';


//TABLES TRANSLATE
// import { TableComponent } from 'app/main/pagina/pulse/4all/translate/table/table.component';
// import { DemoTableComponent } from 'app/main/pagina/pulse/demographictabs/demotranslate/demotable/demotable.component';
// import { EstatusEncuestaComponent } from 'app/main/pagina/pulse/estatus-encuesta/estatus-encuesta.component';

//DRAG

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';

// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
import { AuthGuard } from 'app/auth/auth.guard';

// import { FormDialogComponent } from 'app/main/pagina/pulse/shedulesurvey/formdialog/form.component';

//import { Step1Norm35Component } from '../../pagina/pulse/step1-norm35/step1-norm35.component'; //TEMPORAL

const rutas: Routes = [
  {
      path     : 'pulse/wizard',
      component: WizardLeaderComponent,
      data : {producto : '3'},
      children: [
          { path: '', redirectTo: 'languages', pathMatch: 'full'  },
          // { path: 'languages', component: IdiomasComponent, canActivate: [AuthGuard] },
          // // { path: 'additionals', component: AdditionalComponent, canActivate: [AuthGuard] },
          // // { path: 'collaborators', component: UploadDBComponent, canActivate: [AuthGuard] },
          // // { path: 'collaborators', component: ColaboradoresComponent, canActivate: [AuthGuard] },
          // { path: 'collaborators', component: ColaboradoresV2Component, canActivate: [AuthGuard] },
          // // { path: 'schedule', component: SheduleComponent, canActivate: [AuthGuard] },
          // { path: 'schedule', component: ProgramacionComponent, canActivate: [AuthGuard] },
          // { path: 'mailSending', component: DispatchComponent, canActivate: [AuthGuard] },
          // { path: 'statusSurveys', component: EstatusEncuestaComponent, canActivate: [AuthGuard] },
          // // { path: 'close', component: CloseComponent, canActivate: [AuthGuard] }
          // { path: 'close', component: ProjectDashboardComponent, canActivate: [AuthGuard] }
      ]
  },
];

@NgModule({
  declarations: [
    ///CERTIFICAR
  //  FORALL_COMPONENTES,
    //ForAllTabsComponent,
    // LanguajeComponent,
    // LanguajeListComponent,
    // FormDialogComponent,

    // IDIOMAS
    // IdiomasComponent,
    // ModalIdioma,
    // FORALL
    // ForAllTabsComponent,
    // NativeComponent,
    // SidebarComponent,
    // TranslateComponent,
    // PreviewComponent,
    //DEMOGRAFICOS
    // DemoTabsComponent,
    // PreguntaDemoComponent,
    // DemographicComponent,
    // DemoTranslateComponent,
    // DemoPreviewComponent,
    // DragComponent,
    //ADICIONALES
    //COLABORADORES
    // UploadDBComponent,
    //PROGRAMACION
    // SheduleComponent,

    // FormDialogComponent,
    //ENVIO
    // DispatchComponent,
    //CLOSE
    // CloseComponent,
    // ProjectDashboardComponent,
    // EstatusEncuestaComponent

  ],
  imports     : [
      RouterModule.forChild(rutas),

      MatBadgeModule,
      MatButtonModule,
      MatCheckboxModule,
      MatChipsModule,
      MatStepperModule,
      MatDatepickerModule,
      MatDialogModule,
      MatDividerModule,
      MatExpansionModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatListModule,
      MatMenuModule,
      MatRippleModule,
      MatSelectModule,
      MatSnackBarModule,
      MatTableModule,
      MatSortModule,
      MatToolbarModule,
      MatTooltipModule,
      MatTabsModule,
      MatRadioModule,
      MatProgressBarModule,
      MatProgressSpinnerModule,

      NgxFileDropModule,

      BrowserModule,
      BrowserAnimationsModule,
      DragDropModule,
      MatButtonToggleModule,
      MatCardModule,

      FuseSidebarModule,
      FuseSharedModule,
      FuseDemoModule,
      FuseWidgetModule,
      NgxChartsModule,

      TranslateModule,

      SweetAlert2Module,


      ///MODULOS DE CERTIFICAR
      //LanguajeModule,
      //ForAllModule
  ],
  entryComponents: [
    //modals de elegir idiomas
    // ModalIdioma,
  ]
})
export class WizardPulseRutasModule {
    //const routes = this.rutas;
}


//export const routes = RouterModule.forChild(rutas),
